var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronBottom = function SvgChevronBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0294 167.029C104.305 157.753 119.285 157.658 128.679 166.743L128.971 167.029L256 294.059L383.029 167.029C392.305 157.753 407.285 157.658 416.679 166.743L416.971 167.029C426.247 176.305 426.342 191.285 417.257 200.679L416.971 200.971L272.971 344.971C263.695 354.247 248.715 354.342 239.321 345.257L239.029 344.971L95.0294 200.971C85.6569 191.598 85.6569 176.402 95.0294 167.029Z",
    fill: "#222428"
  })));
};

export { SvgChevronBottom as ReactComponent };
export default __webpack_public_path__ + "static/media/images/chevronBottom.svg";